import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import FormField from 'components/FormField';
import TextArea from 'components/TextArea';
import Text from 'components/Text';
import Stack from 'components/Stack';
import splitInputString from 'utils/splitInputString';
import { validateEmailAddress } from 'utils/emails';
import { useAddMyEmail } from 'actions/userEmails';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AddEmailModal(_ref) {
  var onClose = _ref.onClose,
    existingEmails = _ref.existingEmails;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    input = _useState2[0],
    setInput = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    addedEmails = _useState6[0],
    setAddedEmails = _useState6[1];
  var _useAddMyEmail = useAddMyEmail(),
    addMyEmail = _useAddMyEmail.addMyEmail,
    isPending = _useAddMyEmail.isPending;
  function handleSubmit() {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var splitEmails, invalidFormat, existingEmailsLower, newEmails, response, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            splitEmails = splitInputString(input);
            invalidFormat = splitEmails.filter(function (email) {
              return !validateEmailAddress.test(email);
            });
            if (!invalidFormat.length) {
              _context.next = 1;
              break;
            }
            setError(t('error_invalid_email_item', {
              count: invalidFormat.length,
              invalidItems: invalidFormat.join(', ')
            }));
            return _context.abrupt("return");
          case 1:
            // Filter out emails already on this account (primary or an existing
            // additional email, verified or not) before posting - avoids a
            // round trip for the common case of re-pasting a visible email.
            existingEmailsLower = new Set(existingEmails.map(function (email) {
              return email.toLowerCase();
            }));
            newEmails = splitEmails.filter(function (email) {
              return !existingEmailsLower.has(email.toLowerCase());
            });
            if (newEmails.length) {
              _context.next = 2;
              break;
            }
            onClose();
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            _context.next = 3;
            return addMyEmail(newEmails);
          case 3:
            response = _context.sent;
            setAddedEmails(response.addedEmails.map(function (_ref2) {
              var email = _ref2.email;
              return email;
            }));
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](2);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 4]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  if (addedEmails) {
    return /*#__PURE__*/_jsx(SimpleModal, {
      title: t('modal_email_verification_required_title'),
      body: /*#__PURE__*/_jsxs(Stack, {
        spacing: "xs",
        children: [/*#__PURE__*/_jsx(Text, {
          children: t('modal_email_verification_required_body_1', {
            count: addedEmails.length
          })
        }), /*#__PURE__*/_jsx(Text, {
          children: t('modal_email_verification_required_body_2')
        }), /*#__PURE__*/_jsx(Text, {
          bold: true,
          children: t('modal_email_verification_required_body_3', {
            count: addedEmails.length
          })
        })]
      }),
      buttons: [{
        label: t('actions_ok'),
        variant: 'primary',
        onClick: onClose
      }],
      onClose: onClose
    });
  }
  return /*#__PURE__*/_jsx(SimpleModal, {
    width: "wide",
    title: t('modal_add_additional_email_title'),
    body: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsx(Text, {
        children: t('modal_add_additional_email_body_1')
      }), /*#__PURE__*/_jsx(Text, {
        children: t('modal_add_additional_email_body_2')
      }), /*#__PURE__*/_jsx(Text, {
        bold: true,
        children: t('modal_add_additional_email_body_3')
      }), /*#__PURE__*/_jsx(FormField, {
        label: t('email_colon_plural'),
        alert: error,
        description: t('modal_add_additional_email_description'),
        children: /*#__PURE__*/_jsx(TextArea, {
          maxRows: 3,
          value: input,
          spellCheck: "false",
          autoCorrect: "off",
          placeholder: t('email_placeholder'),
          onChange: function onChange(e) {
            setInput(e.target.value);
            setError('');
          }
        })
      })]
    }),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onClose,
      isDisabled: isPending
    }, {
      label: t('actions_add'),
      variant: 'primary',
      isLoading: isPending,
      isDisabled: !input.trim() || Boolean(error),
      onClick: handleSubmit
    }],
    onClose: onClose
  });
}
export default AddEmailModal;